import { render, staticRenderFns } from "./NewTask.vue?vue&type=template&id=4ebf4302&"
import script from "./NewTask.vue?vue&type=script&lang=ts&"
export * from "./NewTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports